import React from 'react'
import { DesktopHeader } from '../../components/Header/DesktopHeader'
import { MobileHeader } from '../../components/Header/MobileHeader'
import { OrderAlert } from '../../components/Header/OrderAlert'
import { OrderAlertDialog } from '../../components/Header/OrderAlertDialog'

export default function Header() {
  return (
    <>
      <OrderAlert />
      <OrderAlertDialog />
      <DesktopHeader />
      <MobileHeader />
    </>
  )
}
